"use client";

import { IconNoRatingStar, IconRatingStar } from "@repo/assets/images";
import { useFormValidation, useSnackbarHandler } from "@repo/lib/hooks/common";
import { validation } from "@repo/lib/utils";
import { postProductReview } from "@repo/server-actions/product";
import { Button, ErrorMessage, LoadingDots, TextArea } from "@repo/ui";
import { useLocale, useTranslations } from "next-intl";
import { useState, useTransition } from "react";
const formFields = {
  review: "",
  rating: 0
};
const ReviewForm = ({
  id,
  session,
  setOpenReviewForm
}) => {
  const locale = useLocale();
  const t = useTranslations("Common");
  const [isPending, startTransition] = useTransition();
  const [rating, setRating] = useState(0); // State to store the selected rating
  const [hoverRating, setHoverRating] = useState(0); // State to handle hover effect
  const {
    showSnackbar
  } = useSnackbarHandler();
  const {
    formValues,
    setFormValues,
    formErrors,
    setFormErrors,
    handleValidation
  } = useFormValidation(formFields);
  const sumbitForm = async () => {
    startTransition(async () => {
      const response = await postProductReview(id, formValues, session, locale);
      if (response) {
        showSnackbar(response);
        if (response?.success) {
          setOpenReviewForm(false);
        }
      }
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    const errors = validation(formValues, t);
    if (Object.keys(errors).length === 0) {
      sumbitForm();
    } else {
      setFormErrors(errors);
      console.log("Failed to submit the form, please check the form fields");
    }
  };
  const handleStarClick = ratingValue => {
    setRating(ratingValue);
    setFormValues({
      ...formValues,
      rating: ratingValue
    });
    setFormErrors({
      ...formErrors,
      rating: null
    });
    setHoverRating(0); // Reset hover effect after selection
  };
  const handleStarHover = ratingValue => {
    if (ratingValue > rating) {
      setHoverRating(ratingValue); // Only apply hover effect if hovering over unselected stars
    }
  };
  const handleStarMouseLeave = () => {
    setHoverRating(0); // Reset hover effect when the mouse leaves
  };
  return <div className="px-3 py-5" data-sentry-component="ReviewForm" data-sentry-source-file="ReviewForm.jsx">
      <form onSubmit={handleSubmit}>
        <div className="pb-4">
          <p className="text-productDetails-subText mb-2 block pb-1 text-sm font-medium">
            {t("Review")}
          </p>
          <div className="flex">
            {[...Array(5)].map((_, index) => {
            const ratingValue = index + 1;
            return <span key={index} onClick={() => handleStarClick(ratingValue)} onMouseEnter={() => handleStarHover(ratingValue)} onMouseLeave={handleStarMouseLeave} className="cursor-pointer">
                  {ratingValue <= (hoverRating || rating) ? <IconRatingStar className="text-productDetails-reviewStar" /> : <IconNoRatingStar className="text-productDetails-reviewStar" />}
                </span>;
          })}
          </div>
          <ErrorMessage message={formErrors?.rating} data-sentry-element="ErrorMessage" data-sentry-source-file="ReviewForm.jsx" />
        </div>

        <div className="pb-4">
          <TextArea name="review" rows={4} cols={40} placeholder={t("Your_Review")} value={formValues?.review} onChange={handleValidation} label={t("Write_A_Review")} data-sentry-element="TextArea" data-sentry-source-file="ReviewForm.jsx" />
          <ErrorMessage message={formErrors?.review} data-sentry-element="ErrorMessage" data-sentry-source-file="ReviewForm.jsx" />
        </div>
        <Button size="md" type="submit" className="mb-3 w-full font-semibold" variant="primary" disabled={isPending} data-sentry-element="Button" data-sentry-source-file="ReviewForm.jsx">
          {isPending ? <LoadingDots className="bg-white" /> : `${t("Post_Review")}`}
        </Button>
      </form>
    </div>;
};
export default ReviewForm;